import React from 'react';
import ReactDOM from 'react-dom/client';
import './design-system/tokens.css';
import './design-system/components.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { firebaseReady } from './firebase/firebase';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

firebaseReady.finally(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
